export default "__VITE_ASSET__DB4RkTvn__"